import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $casesList, CaseNameType } from '@/entities/cases'
import { $userKeys } from '@/entities/cases'
import { useEffect, useState } from 'react'
import { $userLanguage, $userToken } from '@/entities/user'
import { lang } from '@/shared/constants/lang'
import { Icon } from '@/shared/ui/icon'
import { Glow } from '../glow'
import { CaseSubNameText } from '@/features/cardCase/subname'
import { Spiner } from '../spiner'
import { CaseImage } from './caseImage'
import { darkTheme } from '@/shared/styles/theme/dark'
import { goToShop } from '@/app/routing/events'

export const CaseScaledCard = (props: { lootBoxId: number }) => {
  const caseId = props.lootBoxId
  const cases = useUnit($casesList)
  const _case = cases?.find((__case) => __case.id === caseId)
  const userLang = useUnit($userLanguage)
  const userToken = useUnit($userToken)
  const [boxName, setBoxName] = useState<CaseNameType>('gamed')
  const [boxId, setBoxId] = useState<number>(0)
  const { classes } = useStyles()
  const userKeys = useUnit($userKeys)
  const texts = lang[userLang].pages.boxPage.widgetTexts.lootBoxScaled

  const handleClickBuyMoreKeys = async () => {
    if (userToken) {
      goToShop({ tab: 2 })
    }
  }

  useEffect(() => {
    if (_case) {
      setBoxName(_case.name)
      setBoxId(_case.id)
    }
  }, [_case, userLang])

  const caseName = lang[userLang].pages.boxPage.headings[boxName]

  if (!boxName) return <Spiner variant="secondary" />
  return (
    <>
      {boxName === 'cityholder' && (
        <Glow width={'100%'} backgroundColor={darkTheme.colors.borders.legendary} filter="blur(200px)" top={'-50%'} />
      )}
      <div className={classes.root}>
        <CaseImage caseId={boxId} />
        <div className={classes.arrowAndKeyWrapper}>
          <div />
          <div className={classes.keyBalaceWrapper} onClick={handleClickBuyMoreKeys}>
            <Icon view="gamedKey" width={16} />
            <span className={classes.amoutOfKeys}>{userKeys}</span>
          </div>
        </div>

        <div className={classes.textWrapper}>
          <div className={classes.boxNameAndSubName}>
            <span className={classes.boxName}>{caseName}</span>
            <CaseSubNameText caseName={boxName} />
          </div>

          {_case?.name === 'gamed' ? (
            <span className={classes.plusWrapper}>
              {texts.usersWith}
              <Icon
                view="plusLogo"
                width={48}
                style={{ position: 'relative', marginLeft: '4px', marginRight: '4px', top: '3px' }}
              />
              {lang[userLang].pages.boxPage.widgetTexts.lootBoxScaled.plusUsers}
            </span>
          ) : (
            <p className={classes.description}>
              <span></span>
            </p>
          )}
        </div>
      </div>
    </>
  )
}
